import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/Offshoreengineeringpage.css";

const OffshoreEngineeringPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const bannerSlides = [
    "/wp-content/uploads/2016/02/offshore.jpg",
    "/wp-content/uploads/2016/07/offshore1.jpg",
    "/wp-content/uploads/2016/07/offshore2.jpg",
    "/wp-content/uploads/2016/07/offshore3.jpg",
  ];

  useEffect(() => {
    const t = setInterval(
      () => setCurrentSlide((p) => (p + 1) % bannerSlides.length),
      3000,
    );
    return () => clearInterval(t);
  }, [bannerSlides.length]);

  return (
    <>
      <Header />

      {/* ── Banner – 470px full-width, dots only (no arrows in original) ── */}
      <section id="main-banner" className="oe-banner">
        {bannerSlides.map((src, i) => (
          <img
            key={i}
            src={src}
            alt="Offshore Engineering"
            className={`oe-banner-img${i === currentSlide ? " active" : ""}`}
          />
        ))}

        {/* Hesperiden dots */}
        <div className="oe-dots">
          {bannerSlides.map((_, i) => (
            <span
              key={i}
              className={`oe-dot${i === currentSlide ? " selected" : ""}`}
              onClick={() => setCurrentSlide(i)}
            />
          ))}
        </div>
      </section>

      {/* ── Body ── */}
      <section className="contentwrapper clearfix">
        <div className="content clearfix">
          {/* Breadcrumb */}
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Offshore Engineering</span>
          </div>

          <h1 data-aos="fade-right">Offshore Engineering</h1>

          {/* ── Row 1: image left (col-sm-6) + text right (col-sm-6) ──
               Original uses wpb_left-to-right / wpb_right-to-left animations.
               margin-top: 20% on the text col from vc_custom CSS.            */}
          <div className="oe-two-cols oe-row-1">
            <div className="oe-col-img" data-aos="fade-right">
              <figure className="oe-figure">
                <img
                  src="/wp-content/uploads/2016/02/offshore-engineering.jpg"
                  alt="Offshore Engineering"
                  width="1024"
                  height="768"
                />
              </figure>
            </div>

            <div className="oe-col-text oe-col-text--top-margin" data-aos="fade-left">
              <p>
                Colombo Dockyard has made significant progress and been able to
                forge into top end repair markets in the offshore sector. The
                Offshore Engineering division has managed some unique retrofits
                and repair work creating history in the local maritime industry.
              </p>
            </div>
          </div>

          {/* ── Row 2: text left (col-sm-6) + image right (col-sm-6) ── */}
          <div className="oe-two-cols oe-row-2">
            <div className="oe-col-text oe-col-text--top-margin" data-aos="fade-right">
              <p>
                Some noteworthy projects completed in the offshore sector
                include,
              </p>
              <ul>
                <li data-aos="fade-right" data-aos-delay="100">
                  Major Layup Repairs on Mobile Offshore Drilling Unit (MODU)
                  Sagar Vijay
                </li>
                <li data-aos="fade-right" data-aos-delay="150">Retrofit Repairs on Floating Dock Navy 1</li>
                <li data-aos="fade-right" data-aos-delay="200">
                  Major retrofit repairs on Ocean Research Vessel Sagar Kanya
                </li>
                <li data-aos="fade-right" data-aos-delay="250">Dry Dock repairs on MV Geo Explorer</li>
              </ul>
              <p>
                <a
                  className="dwnload-icon-blue"
                  href="/wp-content/uploads/2016/02/OFFSHORE.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download PDF
                </a>
              </p>
            </div>

            <div className="oe-col-img" data-aos="fade-left">
              <figure className="oe-figure">
                <img
                  src="/wp-content/uploads/2016/02/offshore-engineerings.jpg"
                  alt="Offshore Engineering projects"
                  width="1024"
                  height="768"
                />
              </figure>
            </div>
          </div>
        </div>
        {/* .content */}
      </section>

      <Footer />
      <BackToTop />
    </>
  );
};

export default OffshoreEngineeringPage;
